
import FAQAccordion from '../../../components/base/FAQAccordion';
import { removalsFaqs } from '../../../mocks/faqs';

const RemovalsFAQ = () => {
  return (
    <div>
      <h2 className="font-serif text-4xl font-bold text-charcoal mb-4">
        Removals FAQs
      </h2>
      <p className="text-gray-600 text-lg mb-8 leading-relaxed">
        Common questions about our bakkie removal services in Durban and KwaZulu-Natal
      </p>

      <FAQAccordion faqs={removalsFaqs} />
    </div>
  );
};

export default RemovalsFAQ;
